import { styled } from "@mui/system";

const Container = styled("div")((props) => ({
  display: "flex",
  flexFlow: "column",
  background: "rgb(43,42,42)",
  background: "rgb(0,0,0)",
  background:
    "-moz-linear-gradient(180deg, rgba(12, 12, 12) 0%, rgba(43,42,42,1) 100%)",
  background:
    "-webkit-linear-gradient(180deg, rgba(12, 12, 12) 0%, rgba(43,42,42,1) 100%)",
  background:
    "linear-gradient(180deg, rgba(12, 12, 12) 0%, rgba(43,42,42,1) 100%)",

  padding: "20px 50px",
  gap: props.theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
  width: props.customWidth ?? "100%",
  borderTopLeftRadius: "100px",
  borderBottomLeftRadius: "100px",
  height: "100%",

  "@media screen and (max-width: 900px)": {
    width: "100vw",
    justifyContent: "center",
    padding: "5%",
  },
}));

export const BoxShadowContainer = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};
